import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/Privacy.vue'),
  },
  {
    path: '/terms-conditions',
    name: 'TermsConditions',
    component: () => import('../views/Terms.vue'),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
